import annotationPlugin from "chartjs-plugin-annotation";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { hejriDate } from "@helpers/financial_helper";

const WeatherChart = ({ serverData, charType }) => {
  const isHistory = charType === "weatherHistory";

  // دیتاهای هواشناسی گذشته
  const minTemperatureHistory =
    serverData?.sowingDateRecommendation?.climaticHistoryWeatherData?.map(
      (minTemp) => {
        return minTemp.minTemperature;
      }
    );

  const maxTemperatureHistory =
    serverData?.sowingDateRecommendation?.climaticHistoryWeatherData?.map(
      (maxTemp) => {
        return maxTemp.maxTemperature;
      }
    );

  const precipitationHistory =
    serverData?.sowingDateRecommendation?.climaticHistoryWeatherData?.map(
      (prcpn) => {
        return prcpn.precipitation;
      }
    );

  const localTimeHistory =
    serverData?.sowingDateRecommendation?.climaticHistoryWeatherData?.map(
      (date) => {
        return hejriDate(date.localTime);
      }
    );

  // دیتاهای هواشناسی آینده
  const minTemperatureFuture =
    serverData?.sowingDateRecommendation?.futurePredictionWeatherData?.map(
      (minTemp) => {
        return minTemp.minTemperature;
      }
    );

  const maxTemperatureFuture =
    serverData?.sowingDateRecommendation?.futurePredictionWeatherData?.map(
      (maxTemp) => {
        return maxTemp.maxTemperature;
      }
    );

  const precipitationFuture =
    serverData?.sowingDateRecommendation?.futurePredictionWeatherData?.map(
      (prcpn) => {
        return prcpn.precipitation;
      }
    );

  const localTimeFuture =
    serverData?.sowingDateRecommendation?.futurePredictionWeatherData?.map(
      (date) => {
        return hejriDate(date.localTime);
      }
    );

  const toPersianDigits = (n) =>
    n.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    annotationPlugin
  );

  const data = {
    labels: isHistory ? localTimeHistory : localTimeFuture,
    datasets: [
      {
        label: "حداکثر دمای روزانه",
        data: isHistory ? maxTemperatureHistory : maxTemperatureFuture,
        borderColor: "#FF0000",
        backgroundColor: "#FF0000",
        borderWidth: 1.7,
        borderDash: [],
        fill: false,
        tension: 0.4,
        pointRadius: 0, // حذف نقاط
      },
      {
        label: "حداقل دمای روزانه",
        data: isHistory ? minTemperatureHistory : minTemperatureFuture,
        borderColor: "#147fff",
        backgroundColor: "#147fff",
        borderWidth: 1.2,
        borderDash: [],
        fill: false,
        tension: 0.4,
        pointRadius: 0, // حذف نقاط
      },
      {
        label: "بارش روزانه",
        data: isHistory ? precipitationHistory : precipitationFuture,
        borderColor: "#929296",
        backgroundColor: "#929296",
        borderWidth: 0.9,
        borderDash: [3, 2],
        fill: false,
        tension: 0.5,
        yAxisID: "y-axis-2",
        pointRadius: 0, // حذف نقاط
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false, // حذف labelهای روی نقاط داده‌ای
      },
      legend: {
        position: "top",
        labels: {
          pointStyle: "line", // تغییر شکل نشانگر به خط به جای مربع
          font: {
            size: 14,
            family: " B-NAZANIN",
            weight: "bold",
          },
          boxWidth: 25,
          boxHeight: 1,
          color: "#333333",
        },
      },
      title: {
        display: true,
        font: {
          size: 18,
          family: "B-NAZANIN",
          weight: "bold",
        },
        color: "#333333",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "تاریخ شمسی",
          color: "#333333",
          font: {
            size: 13,
            family: "B-NAZANIN",
            weight: "bold",
          },
        },
        ticks: {
          color: "#666666",
          font: {
            size: 13,
            family: "B-NAZANIN", // استفاده از فونت فارسی
            weight: "bold",
          },
        },
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
          text: "دما (درجه سانتی‌گراد)",
          color: "#333333",
          font: {
            size: 14,
            family: "B-NAZANIN",
            weight: "bold",
          },
        },
        ticks: {
          color: "#666666",
          font: {
            size: 13,
            family: "B-NAZANIN", // استفاده از فونت فارسی
            weight: "bold",
          },
          callback: (value) => toPersianDigits(value), // تبدیل اعداد محور X به فارسی
          callback: function (value) {
            if (value < 0) {
              return Math.abs(value) + "-"; // عدد را مثبت کنید و علامت منفی را در انتها اضافه کنید
            }
            return value;
          },
        },
        // stepSize: 5, // فاصله بین اعداد محور Y چپ
        // min: 0, // مقدار حداقل محور Y چپ
        // max: 40, // مقدار حداکثر محور Y چپ
      },
      "y-axis-2": {
        type: "linear",
        display: true,
        position: "right",
        title: {
          display: true,
          text: "بارش (میلی‌متر)",
          color: "#333333",
          font: {
            size: 16,
            family: "B-NAZANIN",
            weight: "bold",
          },
        },
        ticks: {
          color: "#666666",
          font: {
            size: 13,
            family: "B-NAZANIN", // استفاده از فونت فارسی
            weight: "bold",
          },
          callback: (value) => toPersianDigits(value), // تبدیل اعداد محور X به فارسی
        },
        // stepSize: 5, // فاصله بین اعداد محور Y چپ
        min: 0, // مقدار حداقل محور Y چپ
        // max: 2.5, // مقدار حداکثر محور Y چپ
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  return (
    <div className="flex justify-center w-full -mt-14">
      <div className="flex-1 justify-center max-w-[900px]">
        <Line data={data} options={options} />
      </div>
    </div>
  );
};

export default WeatherChart;
